import {
  Activity,
  Blocks,
  Fingerprint,
  Landmark,
  Settings,
  Users,
} from 'lucide-react';

import { Command } from '@components/features/CommandMenu/Command';
import { useCurrentTeam } from '@queries/user';

export function TeamCommands() {
  const { team } = useCurrentTeam();

  if (!team) return null;

  return (
    <>
      <Command
        type="route"
        id="team-settings"
        label="Settings"
        group={team.name}
        icon={<Settings />}
        href={`/${team.uuid}/settings/team`}
        keywords={['general']}
        context="team"
      />
      <Command
        type="route"
        id="team-integrations"
        label="Integrations"
        group={team.name}
        icon={<Blocks />}
        href={`/${team.uuid}/settings/team/integrations`}
        context="team"
        keywords={['datadog', 'vanta', 'third party']}
      />
      <Command
        type="route"
        id="team-members"
        label="Members"
        group={team.name}
        icon={<Users />}
        href={`/${team.uuid}/settings/team/members`}
        context="team"
      />
      <Command
        type="route"
        id="team-security"
        label="Security"
        group={team.name}
        icon={<Fingerprint />}
        href={`/${team.uuid}/settings/team/security`}
        context="team"
      />
      <Command
        type="route"
        id="team-activity"
        label="Activity"
        group={team.name}
        icon={<Activity />}
        href={`/${team.uuid}/settings/team/activity`}
        context="team"
      />
      <Command
        type="route"
        id="team-billing"
        label="Billing"
        group={team.name}
        icon={<Landmark />}
        href={`/${team.uuid}/settings/team/billing`}
        context="team"
      />
    </>
  );
}
